<template>
  <div class="sp_emailRecord">
    <el-dialog title="Email Records Detail"
               :visible="emailRecordMsg.show"
               width="50%"
               :before-close="handleClose"
               :append-to-body='true'>
      <div class="content">
        <div class="case-no">
          <span>Case NO：</span>
          <span>{{emailRecordMsg.row.caseNo}}</span>
        </div>
        <div class="title">{{emailRecordMsg.row.emailTitle}}</div>
        <div class="detail-content">
          <div class="label-content">
            <span class="label">From：</span>
            <span class="item"
                  v-html="emailRecordMsg.row.email"></span>
          </div>
          <div class="label-content">
            <span class="label">To：</span>
            <span class="item">{{emailRecordMsg.row.ccEmail}}</span>
          </div>
          <div class="label-content">
            <span class="label">CC：</span>
            <span class="item">{{emailRecordMsg.row.ccEmail}}</span>
          </div>
          <div class="label-content">
            <span class="label">Date：</span>
            <span class="item">{{ moment(emailRecordMsg.row.createdDate).format('YYYY-MM-DD') }}</span>
          </div>

          <div class="label-content">
            <span class="label">Attachments：</span>
            <span class="item"></span>
          </div>
        </div>
      </div>
      <el-row style="padding:16px 20px">
        <el-col :span="24">
          <p>
            <span style="word-break: break-word; width:100%; max-height:300px; overflow: auto; display: inline-block; padding:5px 0px;"
                  v-html="emailRecordMsg.row.emailContent"></span>
          </p>
        </el-col>
      </el-row>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose"
                   size="medium">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "emailRecord",
  props: {
    emailRecordMsg: {
      type: Object,
      required: true,
      default: () => { }
    }
  },
  data () {
    return {

    }
  },

  methods: {
    handleClose () {
      this.$emit('emailRecordChildMsg', { close: false })
    }
  },

  computed: {
    moment () {
      return moment
    }
  }
}
</script>

<style scoped lang="scss">
.sp_emailRecord {
  width: 100%;
}
.content {
  padding: 16px 20px 0;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e1e6ed;
  .case-no {
    height: 20px;
    line-height: 20px;
    margin-bottom: 4px;
    font-size: 14px;
    color: #333940;
  }
  .title {
    font-size: 18px;
    color: #13161a;
    font-weight: 500;
    margin-bottom: 8px;
  }
  .detail-content {
    padding: 8px 0;
    .label-content:nth-child(5) {
      margin-bottom: 0;
    }
    .label-content {
      height: 20px;
      margin-bottom: 6px;
      font-size: 14px;
      .label {
        display: inline-block;
        min-width: 96px;
        text-align: right;
        color: #77808c;
      }
      .item {
        display: inline-block;
        color: #333940;
      }
    }
  }
}
/deep/.el-dialog__title {
  font-size: 16px;
  color: #13161a;
  line-height: 16px;
}
/deep/.el-dialog__body {
  padding: 0 20px !important;
}
</style>